import download from 'downloadjs';

import {bytesToBase64} from './return-document.util';

function isFirefoxIOS() {
	return typeof navigator !== 'undefined' && /FxiOS/.test(navigator.userAgent);
}

export function downloadPdf(pdfBytes: Uint8Array, fileName: string) {
	if (isFirefoxIOS()) {
		downloadFirefoxIOSPdf(pdfBytes, fileName);
		return;
	}

	if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
		const pdfDataUrl = `data:application/octet-stream;base64,${bytesToBase64(pdfBytes)}`;
		download(pdfDataUrl, fileName, 'application/octet-stream');
		return;
	}

	download(pdfBytes, fileName, 'application/pdf');
}

async function downloadFirefoxIOSPdf(pdfBytes: Uint8Array, fileName: string) {
	const pdfFile = new File(
		[pdfBytes.buffer.slice(pdfBytes.byteOffset, pdfBytes.byteOffset + pdfBytes.byteLength) as ArrayBuffer],
		fileName,
		{type: 'application/pdf'}
	);

	const shareData = {files: [pdfFile]};
	if (navigator.share) {
		try {
			if (!navigator.canShare || navigator.canShare({files: [pdfFile]})) {
				await navigator.share(shareData);
				return;
			}
		} catch {
			// Fall through to the browser download path below.
		}
	}

	const objectUrl = URL.createObjectURL(pdfFile);
	const link = document.createElement('a');

	link.href = objectUrl;
	link.download = fileName;
	link.style.display = 'none';

	document.body.appendChild(link);
	link.click();
	link.remove();

	setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
}
